export default "__VITE_ASSET__BhmoNm9s__"